import type { ReactNode } from "react";

import {
  GearIcon,
  ScoreboardIcon,
  TrophyIcon,
  PersonIcon,
  ClipboardCheckIcon,
} from "../../shell/SectionIcon";

/** Native disclosure keeps fields mounted: collapsing never resets a draft. */
export function RulesSection({
  title,
  description,
  summary,
  advanced = false,
  children,
  icon = "settings",
}: {
  title: string;
  description: string;
  summary?: string | undefined;
  advanced?: boolean | undefined;
  children: ReactNode;
  icon?: "settings" | "calendar" | "picks" | "people" | "scoring";
}): ReactNode {
  const Icon = {
    settings: GearIcon,
    calendar: ScoreboardIcon,
    picks: ClipboardCheckIcon,
    people: PersonIcon,
    scoring: TrophyIcon,
  }[icon];
  return (
    <details
      open={!advanced}
      className="rounded-lg border border-hairline bg-surface p-4"
    >
      <summary className="flex cursor-pointer items-center gap-3 text-ink">
        <span
          aria-hidden="true"
          className="rounded-lg bg-primary-tint p-2 text-primary"
        >
          <Icon className="size-icon-md" />
        </span>
        <span className="flex-1">
          <h2 className="text-body-strong">{title}</h2>
          <span className="block text-caption text-ink-secondary">
            {description}
          </span>
          {summary ? (
            <span className="block text-caption text-ink-secondary">
              {summary}
            </span>
          ) : null}
        </span>
        <span aria-hidden="true">⌄</span>
      </summary>
      <div className="mt-4 flex flex-col gap-4 border-t border-hairline pt-4">
        {children}
      </div>
    </details>
  );
}
